import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NativeActivityIndicator from '../../../NativeActivityIndicator';

const propTypes = {
  className: PropTypes.string,
};

const DesignEditorLoadingIndicator = ({ className }) => {
  const classes = classNames({
    'design-editor-loading': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <NativeActivityIndicator />
    </div>
  );
};

DesignEditorLoadingIndicator.propTypes = propTypes;

export default DesignEditorLoadingIndicator;
